import { render, staticRenderFns } from "./App.vue?vue&type=template&id=20aa1225&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=20aa1225&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=20aa1225&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa1225",
  null
  
)

export default component.exports